import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectQuotView } from '../../Selectors/Master/ItemSelectors';
import { fetchQuotViewlist } from '../../../Store/PHPSlice/Sale/Quotation';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';

const QuotationInfo = () => {
    const [formData, setFormData] = useState({
        itemNm: '',
        firmNm: '',
        priceNm: '',
        partyNm: '',
        schlNm: '',
        jobrate: '',
        outSrc: '',
        extra: '',
        mcloth: '',
        mrate: '',
        mpanna: '',
        m1cloth: '',
        m1rate: '',
        m1panna: '',
        m2cloth: '',
        m2rate: '',
        m2panna: '',
        m3cloth: '',
        m3rate: '',
        m3panna: '',
    });
    const { Id } = useParams();
    const dispatch = useDispatch();
    const viewlist = useSelector(selectQuotView);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed
    useEffect(() => {
        dispatch(fetchQuotViewlist(Id))
    }, [Id, dispatch]);
    useEffect(() => {
        if (viewlist.data && viewlist.data.length > 0) {
            const item = viewlist.data[0];
            setFormData(prev => ({
                ...prev,
                itemNm: item.itemNm || '',
                firmNm: item.firmNm || '',
                priceNm: item.grpNm || '',
                partyNm: item.partyNm || '',
                schlNm: item.schoolNm || '',
                jobrate: item.jobrate || '',
                outSrc: item.outSrc || '',
                extra: item.extra || '',
                mcloth: item.clothNm || '',
                mrate: item.rate || '',
                mpanna: item.panna || '',
                m1cloth: item.m1cloth || '',
                m1rate: item.m1rate || '',
                m1panna: item.m1panna || '',
                m2cloth: item.m2cloth || '',
                m2rate: item.m2rate || '',
                m2panna: item.m2panna || '',
                m3cloth: item.m3cloth || '',
                m3rate: item.m3rate || '',
                m3panna: item.m3panna || '',
            }));
        }
    }, [viewlist]);

    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };
    var itemData = viewlist.avgs.length > 0 ? {
        size: viewlist.avgs.map(val => val.size),
        mavg: viewlist.avgs.map(val => parseFloat(val.mavg)),
        m1avg: viewlist.avgs.map(val => parseFloat(val.m1avg)),
        m2avg: viewlist.avgs.map(val => parseFloat(val.m2avg)),
        m3avg: viewlist.avgs.map(val => parseFloat(val.m3avg)),
        rate: viewlist.avgs.map(val => parseFloat(val.rate)),
        mrp: viewlist.avgs.map(val => parseFloat(val.mrp))
    } : [];




    const renderTableRow = (size, index) => {
        const newAvgM = itemData.mavg[index];
        const newAvgM1 = itemData.m1avg[index];
        const newAvgM2 = itemData.m2avg[index];
        const newAvgM3 = itemData.m3avg[index];

        var m0rate = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.rate)) : 0;
        var m1rate = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.m1rate)) : 0;
        var m2rate = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.m2rate)) : 0;
        var m3rate = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.m3rate)) : 0;

        var outSrc = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.outSrc)) : 0;

        let mCal = parseFloat(m0rate) * parseFloat(outSrc) / 100 + parseFloat(m0rate);
        let m1Cal = parseFloat(m1rate) * parseFloat(outSrc) / 100 + parseFloat(m1rate);
        let m2Cal = parseFloat(m2rate) * parseFloat(outSrc) / 100 + parseFloat(m2rate);
        let m3Cal = parseFloat(m3rate) * parseFloat(outSrc) / 100 + parseFloat(m3rate);

        let fm0 = mCal * parseFloat(newAvgM) / 100;
        let fm1 = m1Cal * parseFloat(newAvgM1) / 100;
        let fm2 = m2Cal * parseFloat(newAvgM2) / 100;
        let fm3 = m3Cal * parseFloat(newAvgM3) / 100;

        let clothrate = Math.round(fm0) + Math.round(fm1) + Math.round(fm2) + Math.round(fm3);
        var jobrate = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.jobrate)) : 0;
        let calJob = Math.round(clothrate) + parseFloat(jobrate);
        var extra = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.extra)) : 0;
        let cost = Math.round(calJob) + parseFloat(extra);

        let firmPer = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.firmPer)) : 0;
        let mrp = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.mrpPer)) : 0;

        let profit = cost * parseFloat(firmPer) / 100;
        let finalRate = Math.round(profit + cost);

        let calMrp1 = parseFloat(mrp) / 100;
        let calMrp2 = 1 - calMrp1;
        let finalMrp = Math.round(finalRate / calMrp2);

        let mod = finalMrp % 5;
        if (mod > 2.5) {
            let diff = 5 - mod;
            var ans = finalMrp + Math.round(diff);
        } else {
            ans = finalMrp - Math.round(mod);
        }
        return (
            <TableRow key={index}>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{size}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{newAvgM}</TableCell>
                {formData.m1cloth !== '0' &&
                    <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{newAvgM1}</TableCell>}
                {formData.m2cloth !== '0' &&
                    <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{newAvgM2}</TableCell>}
                {formData.m3cloth !== '0' &&
                    <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{newAvgM3}</TableCell>}
                <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{Math.round(clothrate)}</TableCell>
                {/* <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{Math.round(calJob)}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{Math.round(cost)}</TableCell> */}
                <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{Math.round(profit)}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{Math.round(finalRate)}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{Math.round(ans)}</TableCell>
            </TableRow>
        );
    };


    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '5% 0%', width: '100%' }} ref={componentRef}>

                        <h3 className='centered-heading'>Quotation View</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                            <tbody>

                                <tr>
                                    <td style={{ width: '200px' }}>Item Name</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{formData.itemNm}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Job Rate</td>
                                    <td>:</td>
                                    <td style={{ padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.jobrate}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Firm Name</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.firmNm}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Extra</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.extra}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Price List</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: ' 0 1.5%' }}>{formData.priceNm}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Out Source</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.outSrc}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Main Cloth</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.mcloth} <b>Panna:{formData.mpanna}</b> <b className='red-color'>Rate:{formData.mrate}</b></td>
                                    {formData.m1cloth !== '0' && (
                                        <>
                                            <td style={{ width: '200px', paddingLeft: '2%' }}>Matching Cloth-1</td>
                                            <td>:</td>
                                            <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.m1cloth} <b>Panna: {formData.m1panna}</b> <b className='red-color'> Rate: {formData.m1rate}</b></td>
                                        </>
                                    )}
                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Party</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='dark-color'>{formData.partyNm}</td>
                                    {formData.m2cloth !== '0' && (
                                        <>
                                            <td style={{ width: '200px', paddingLeft: '2%' }}>Matching Cloth-2</td>
                                            <td>:</td>
                                            <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.m2cloth} <b>Panna: {formData.m2panna}</b> <b className='red-color'> Rate: {formData.m2rate}</b></td>
                                        </>
                                    )}
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>School</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: '  0.2% 1.5%' }} className='dark-color'>{formData.schlNm}</td>
                                    {formData.m3cloth !== '0' && (
                                        <>
                                            <td style={{ width: '200px', paddingLeft: '2%' }}>Matching Cloth-3</td>
                                            <td>:</td>
                                            <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.m3cloth} <b>Panna: {formData.m3panna}</b> <b className='red-color'> Rate: {formData.m3rate}</b></td>
                                        </>
                                    )}
                                </tr>


                            </tbody>

                        </table>


                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow className='tbl-row'>
                                        <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Size</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Avrg.Meter</TableCell>
                                        {formData.m1cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>M1 Avrg.Meter</TableCell>}
                                        {formData.m2cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>M2 Avrg.Meter</TableCell>}
                                        {formData.m3cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>M3 Avrg.Meter</TableCell>}
                                        <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Cloth Rate</TableCell>
                                        {/* <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Job Rate</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Extra</TableCell> */}
                                        <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Profit</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Final Rate</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>MRP</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {itemData.size ? itemData.size.map((item, index) => renderTableRow(item, index)) : ''}
                                </TableBody>
                            </Table>
                        </TableContainer>

                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
};

export default QuotationInfo;
